import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import WebService from './webservice.js'
import Axios from 'axios'

// Directives
import './directives/required.js'

// Filters
import './filters/all.js'

// Start Define Layout
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css' // This line here
Vue.use(VueMaterial)

import "./assets/aquincum/styles.css";
import "./assets/custom.scss";


// End define layout

Vue.config.productionTip = false

// Global Component
import PageHeading from './components/PageHeading'
Vue.component('PageHeading', PageHeading)

import DataTable from "./components/DataTable/DataTable"
Vue.component('DataTable', DataTable)

// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
// import VueVirtualScroller from 'vue-virtual-scroller'
// Vue.use(VueVirtualScroller)

import virtualList from 'vue-virtual-scroll-list'
Vue.component('virtual-list', virtualList)


// Axios
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token
}
Vue.prototype.$http.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    localStorage.removeItem('token')
    delete Axios.defaults.headers.common['Authorization']
    router.push({ name: 'login' })
  }
  return Promise.reject(error.response);
});



Vue.mixin({
  data: function () {
    return {
      Notification: null,
      NotificationTimer: null,
      publicPath: process.env.BASE_URL,
      get WebService() {
        return WebService;
      },

    }
  },
  watch: {
    Notification() {
      clearTimeout(this.NotificationTimer)
      this.NotificationTimer = setTimeout(() => {
        this.Notification = null
      }, 3000)
    }
  },
  methods: {



    alertNotice(config) {

      var content = ''
      var message

      if( config.content && typeof config.content.errors !== 'undefined' ) {
        message = config.content.errors
      } else if ( config.content && typeof config.content.message !== 'undefined' ) {
        message = config.content.message
      } else {
        message = config.content
      }

      if (message instanceof Array) {
        message.forEach((item) => {
          content += "<div>" + item + "</div>"
        })
      }
      else if (message instanceof Object) {
        Object.keys(message).forEach((key) => {
          content += "<div>" + message[key] + "</div>"
        })
      }
      else {
        content = message
      }

      config.content = content
      this.$root.$data.Notification = config

    },
    doLogout() {

      if( !this.isAuth() ) return

      this.$root.$data.AuthData = null
      localStorage.removeItem('token')
      delete Axios.defaults.headers.common['Authorization']
      this.$router.push({ name: 'login' })
    },
    isAuth() {
      return localStorage.getItem("token") != null
    },
    hasPermission(permission) {
      let data = this.$root.$data.AuthData
      if (data && data.permissions && data.permissions.length > 0 && data.permissions.indexOf(permission) >= 0) {
        return true
      }
    },
    hasGroupPermission(groupName) {
      let data = this.$root.$data.AuthData
      if (data && data.permissions && data.permissions.length > 0) {
        return data.permissions.some(function (item) {
          let group = item.substring(item.indexOf(' ') + 1);
          if (groupName === group)
            return true
        })
      }
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }
})

var mixin = {
  data: function () {
    return {
      mouseMoveTimer: null,
      lastMouseMove: null
    }
  },
  created: function () {

    let lastMouseMove = localStorage.getItem('lastMouseMove')
    if( lastMouseMove && (new Date()).getTime() - lastMouseMove >= 30 * 1000 * 60 )
      this.doLogout()

    localStorage.setItem('lastMouseMove', (new Date()).getTime())

    this.setMouseTimer()
    window.addEventListener('mousemove', () => {

      localStorage.setItem('lastMouseMove', (new Date()).getTime())

      if( this.mouseMoveTimer )
        clearTimeout(this.mouseMoveTimer)
      this.setMouseTimer()
    })
  },
  methods: {
    setMouseTimer() {
      this.mouseMoveTimer = setTimeout(() => {
        clearTimeout(this.mouseMoveTimer)
        this.doLogout()
        this.setMouseTimer()
      }, 30 * 1000 * 60 )
    },
  }
}

new Vue({
  mixins: [mixin],
  router,
  store,
  render: h => h(App),
}).$mount('#app')
